'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _repeat = require('lodash/repeat');
var _forOwn = require('lodash/forOwn');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _repeat__default = /*#__PURE__*/_interopDefaultLegacy(_repeat);
var _forOwn__default = /*#__PURE__*/_interopDefaultLegacy(_forOwn);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MASK_CHAR = '*';

var _parse = function _parse(string) {
  if (typeof string === 'string') {
    try {
      return JSON.parse(string);
    } catch (err) {
      return null;
    }
  }

  return null;
};

var _maskedString = function _maskedString(_ref) {
  var length = _ref.length,
      maskChar = _ref.maskChar;
  return _repeat__default["default"](maskChar, length);
};

var masked = function masked(data, keys, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      omitKeys = _ref2.omitKeys;

  if (!data) {
    return null;
  }

  if (typeof data !== 'object' && !_parse(data)) {
    return data;
  }

  if (!keys || !Array.isArray(keys) && typeof keys !== 'string') {
    if (!keys) {
      throw new Error('Second parameter `keys` not given');
    }

    throw new TypeError("Expected a string or array, got " + typeof keys);
  }

  var newData = _parse(data) || data;

  if (Array.isArray(newData)) {
    newData = newData.map(function (newData) {
      if (typeof newData !== 'object') {
        return newData;
      }

      return masked(newData, keys, {
        omitKeys: omitKeys
      });
    });
  } else {
    newData = _objectSpread({}, newData);

    _forOwn__default["default"](newData, function (value, key) {
      if (typeof value === 'object') {
        if (Array.isArray(value) && Array.isArray(keys) && keys.includes(key)) {
          if (omitKeys) {
            delete newData[key];
          } else {
            newData[key] = value.map(function () {
              return _maskedString({
                length: 8,
                maskChar: MASK_CHAR
              });
            });
          }
        } else {
          newData[key] = masked(value, keys, {
            omitKeys: omitKeys
          });
        }
      } else if (key === keys || Array.isArray(keys) && keys.includes(key)) {
        if (omitKeys) {
          delete newData[key];
        } else {
          newData[key] = _maskedString({
            length: 8,
            maskChar: MASK_CHAR
          });
        }
      }
    });
  }

  return typeof data === 'string' && _parse(data) ? JSON.stringify(newData) : newData;
};

exports["default"] = masked;
